import { render, staticRenderFns } from "./archivesInfo.vue?vue&type=template&id=dc45f4aa&scoped=true&"
import script from "./archivesInfo.vue?vue&type=script&lang=js&"
export * from "./archivesInfo.vue?vue&type=script&lang=js&"
import style0 from "./archivesInfo.vue?vue&type=style&index=0&id=dc45f4aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc45f4aa",
  null
  
)

export default component.exports